import { render, staticRenderFns } from "./werlotus.html?vue&type=template&id=5886655e&scoped=true&"
import script from "./werlotus.vue?vue&type=script&lang=js&"
export * from "./werlotus.vue?vue&type=script&lang=js&"
import style0 from "./werlotus.scss?vue&type=style&index=0&id=5886655e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5886655e",
  null
  
)

export default component.exports